import api from "./api";
import { buildWhatsAppBrandedMessage, CLINIC } from "./clinic";
import { openWhatsAppRaw } from "./whatsapp";

export async function shareEducationArticle(doc, patient = null) {
  const body = doc.article_raw || doc.article;
  if (!body) throw new Error("No article to share");
  let recipient = patient;
  if (doc.patient_id) {
    // Fetch current recipient rather than retaining a previous patient's number.
    recipient = (await api.get(`/patients/${doc.patient_id}`)).data.patient;
    if (!recipient?.mobile) throw new Error("No mobile number on file for this patient");
    await api.post("/education/share", {
      patient_id: doc.patient_id, topic: doc.topic, module_id: doc.module_id,
      language: doc.language, article_id: doc.article_id,
    });
  }
  const msg = ["en", "mr"].includes(doc.language)
    ? buildWhatsAppBrandedMessage({ lang: doc.language, title: doc.topic, body, kind: "education" })
    : [`*${CLINIC.name}*`, CLINIC.doctorName, "", body, "", (CLINIC.phones || []).join(" · ")].filter((v) => v != null).join("\n");
  if (recipient?.mobile) openWhatsAppRaw(recipient.mobile, msg);
  else window.open(`https://wa.me/?text=${encodeURIComponent(msg)}`, "_blank", "noopener,noreferrer");
}